import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AddFournisseurAgreeComponent } from "./add-fournisseur-agree/add-fournisseur-agree.component";
import { EditFournisseurAgreeComponent } from "./edit-fournisseur-agree/edit-fournisseur-agree.component";
import { EditExpositionNetteFourAgreeComponent } from "./edit-exposition-nette-four-agree/edit-exposition-nette-four-agree.component";
import { FournisseurAgreeService } from "../core/service/fournisseur-agree.service";
import { FournisseurAgreeDTO } from "../core/model/fournisseuragree/fournisseur-agree-dto";

@Component({
  selector: "app-fournisseur-agree",
  templateUrl: "./fournisseur-agree.component.html",
  styleUrls: ["./fournisseur-agree.component.scss"],
})
export class FournisseurAgreeComponent implements OnInit {
  fournisseurAgrees: FournisseurAgreeDTO[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _fournisseurAgreeService: FournisseurAgreeService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getFournisseurAgrees();
  }

  getFournisseurAgrees() {
    this._fournisseurAgreeService.findAll().subscribe(
      (data) => {
        this.fournisseurAgrees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddFournisseurAgreeComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getFournisseurAgrees();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(id) {
    const modalRef = this.modalService.open(EditFournisseurAgreeComponent, {
      centered: true,
    });
    modalRef.componentInstance.id = id;

    modalRef.result.then(
      (data) => {
        // on close
        this.getFournisseurAgrees();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  editExpositionNette(id) {
    const modalRef = this.modalService.open(
      EditExpositionNetteFourAgreeComponent,
      { centered: true }
    );
    modalRef.componentInstance.id = id;

    modalRef.result.then(
      (data) => {
        // on close
        this.getFournisseurAgrees();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
